import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CoreRoutingModule } from '@configuration/core/core-routing.module';
import { configurationEnvironment } from '@configuration/environment/environment.configuration';
import { ConfigurationSharedModule } from '@configuration/shared/shared.module';
import { PreviewRefreshInterceptor } from '@configuration/shared/services/preview-refresh.interceptor';
import { environment } from '@environment/environment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ResilientTranslateLoader } from '@shared/loaders/resilient-translate.loader';
import { InterceptorService } from '@shared/services/interceptor.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';
import { HIGHCHARTS_MODULES } from 'angular-highcharts';
import more from 'highcharts/esm/highcharts-more.src';
import drilldown from 'highcharts/esm/modules/drilldown.src';
import Highcharts from 'highcharts/esm/highcharts.src';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideNgxMask } from 'ngx-mask';
import { FacebookPixelModule } from '@shared/modules/facebook-pixel.module';
import { QuillModule } from 'ngx-quill';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';

// The app has no dark theme; keep Highcharts 13's adaptive palette from
// following the OS color scheme (black chart backgrounds on dark-mode systems)
Highcharts.setOptions({ palette: { colorScheme: 'light' } });

export const createTranslateLoader = (http: HttpClient) =>
  new ResilientTranslateLoader(
    new TranslateHttpLoader(http, './assets/i18n/', '.json')
  );

@NgModule({ exports: [RouterModule, ConfigurationSharedModule],
    declarations: [], imports: [ConfigurationSharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        CoreRoutingModule,
        ProgressbarModule,
        NgIdleKeepaliveModule.forRoot(),
        FacebookPixelModule.forRoot({
            enabled: environment.FB_PIXEL.IS_ENABLED,
            pixelId: environment.FB_PIXEL.PIXEL_ID
        }),
        QuillModule.forRoot(),
        NgxStripeModule.forRoot(configurationEnvironment.STRIPE.PUBLISHABLE_KEY),
        ModalModule,
        UiSwitchModule.forRoot({
            size: 'small',
            color: '#21CE99',
            defaultBgColor: '#FF2721',
            defaultBoColor: 'rgba(0, 0, 0, 0.1)'
        }),
        LoggerModule.forRoot({
            // serverLoggingUrl: '/logs',
            level: environment.IS_PRODUCTION
                ? NgxLoggerLevel.ERROR
                : NgxLoggerLevel.DEBUG
            // serverLogLevel: NgxLoggerLevel.ERROR
        }),
        ToastrModule.forRoot({
            timeOut: 2000,
            toastClass: 'ngx-toastr v-toastr',
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })], providers: [
        provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'configuration.vitay.io' }), withLocalStorage(), withSessionStorage()),
        CookieService,
        CustomPreloadingStrategy,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PreviewRefreshInterceptor,
            multi: true
        },
        {
            provide: HIGHCHARTS_MODULES,
            useFactory: () => [more, drilldown]
        },
        provideNgxMask(),
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule {}
